import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IStaffUser } from "../../models/StaffUser/StaffUser";
import { StaffUserQueryKeys } from "./keys";

/**
 * Staff directory from Firebase Auth. Customers sign in via SSO through Betty,
 * so every Firebase user is a member of staff.
 */
export default function useStaffUsers() {
  const { get } = useApiHelper();

  const staffUsers = useQuery({
    queryKey: StaffUserQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<IStaffUser[]>>("/staff-users").then(
        (res) => res.data,
      ),
    // The API caches this for 5 minutes; no need to refetch it aggressively.
    staleTime: 1000 * 60 * 5,
  });

  return {
    staffUsers,
  };
}
